



















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import firebase from 'firebase';
import { GrowthCycle } from '@/models/growth-cycle';
import { GrowthCycleTemplate } from '@/models/growth-cycle-template';
import { Variety } from '@/models/variety';
import { TaskName } from '@/models/todo';
import { Farm } from '@/models/farm';
import TodoService from '@/services/todo-service';
import moment from 'moment';
import GrowthCycles from '../../views/GrowthCycles.vue';

@Component
export default class GrowthCyclesComponent extends Vue {
    @State('growthCycles') private growthCyclesState: any;
    @State('growthCycleTemplates') private growthCycleTemplatesState: any;
    @State('allVarieties') private allVarietiesState: any;
    @Action('getGrowthCycles') private getGrowthCyclesAction: any;
    @Action('getGrowthCycleTemplates') private getGrowthCycleTemplatesAction: any;
    @Action('addGrowthCycle') private addGrowthCycleAction: any;
    @Action('getAllVarieties') private getAllVarietiesAction: any;

    private isAdding = false;
    private currentFarm: any = {};
    private showSelectFarmAlert: boolean = false;
    private selectedGrowthCycles: GrowthCycle[] = [];

    private initGrowthCycleFields = {
        name: '',
        varietyId: '',
        varietyName: '',
        growthCycleTemplateId: '',
        growthCycleTemplateName: '',
        startedAt: '',
        isWatered: false,
        germinationCells: 0,
     };

    private newGrowthCycleFields:
        {name: string,
        varietyId: string;
        varietyName: string;
        growthCycleTemplateId: string,
        growthCycleTemplateName: string,
        startedAt: string|Date,
        isWatered: boolean,
        germinationCells: number} =
            this.initGrowthCycleFields;

    private templateSelections: Array<{text: string, value: string}> = [];
    private varietySelections: Array<{text: string, value: string}> = [];

    private created(): void {
        if (this.growthCyclesState.length === 0) {
            this.getGrowthCyclesAction();
        }

        this.$store.watch(
            (state) => {
                return [this.$store.state.currentFarm, this.$store.state.growthCycles];
            },
            ([currentFarm, cycles]) => {
                this.currentFarm = currentFarm;
                this.filterGrowthCycles(cycles, currentFarm);
            },
            {
                immediate: true,
            });

        this.$store.watch(
            (state) => {
                return this.$store.state.growthCycleTemplates;
            },
            (newVal: GrowthCycleTemplate[]) => {
                newVal.map((template: GrowthCycleTemplate) => {
                    this.templateSelections.push({
                        text: template.name,
                        value: template.id!!,
                    });
                });
            },
        );

        this.$store.watch(
            (state) => {
                return this.$store.state.allVarieties;
            },
            (newVal: Variety[]) => {
                newVal.map((variety: Variety) => {
                    this.varietySelections.push({
                        text: variety.name,
                        value: variety.id!!,
                    });
                });
            },
        );
    }

    private filterGrowthCycles(cycles: GrowthCycle[], farm: Farm): void {
        this.selectedGrowthCycles = cycles.filter((cycle: GrowthCycle) => {
            return cycle.farmId.id === farm.id;
        });
    }

    private toggleAdding(): void {
        if (!this.currentFarm.id) {
            this.showSelectFarmAlert = true;
            return;
        }

        this.isAdding = true;

        // Clear array without creating a new object
        this.varietySelections.length = 0;
        this.templateSelections.length = 0;

        this.getGrowthCycleTemplatesAction();
        this.getAllVarietiesAction();
    }

    private submit(): void {
        const templatesRef = firebase.firestore().collection('growthCycleTemplates');
        const varietiesRef = firebase.firestore().collection('varieties');
        const farmsRef = firebase.firestore().collection('farms');
        const farmRef = farmsRef.doc(this.currentFarm.id);

        const templateReference = this.newGrowthCycleFields.growthCycleTemplateId
            ? templatesRef.doc(this.newGrowthCycleFields.growthCycleTemplateId)
            : null;

        const growthCycleTemplateName = this.newGrowthCycleFields.growthCycleTemplateId
            ? this.templateSelections.find((selection) => {
                return selection.value === this.newGrowthCycleFields.growthCycleTemplateId;
            })!!.text
            : '';

        const varietyReference = this.newGrowthCycleFields.varietyId
            ? varietiesRef.doc(this.newGrowthCycleFields.varietyId)
            : null;

        const varietyName = this.newGrowthCycleFields.varietyId
            ? this.varietySelections.find((selection) => {
                return selection.value === this.newGrowthCycleFields.varietyId;
            })!!.text
            : '';

        const startedAt = this.newGrowthCycleFields.startedAt
            ? new Date(this.newGrowthCycleFields.startedAt)
            : new Date();

        const germinationStartedAt = this.newGrowthCycleFields.isWatered
            ? new Date(this.newGrowthCycleFields.startedAt)
            : null;

        if (templateReference) {
            templateReference.get().then((value: any) => {
                const templateData = value.data() as GrowthCycleTemplate;

                const endDate = moment()
                    .add(templateData.daysInGermination, 'days')
                    .add(templateData.daysInPropagation, 'days')
                    .add(templateData.daysInHighDensity, 'days')
                    .add(templateData.daysInFinishedSpacing, 'days');

                const params = {
                    ...this.newGrowthCycleFields,
                    startedAt,
                    germinationStartedAt,
                    growthCycleTemplateId: templateReference,
                    growthCycleTemplateName,
                    varietyId: varietyReference,
                    varietyName,
                    estimatedHarvestDate: endDate.toDate(),
                    isCompleted: false,
                    farmId: farmRef,
                };

                this.isAdding = false;
                // Adding the first todo is a side effect of this action
                this.addGrowthCycleAction(params);
                this.resetForm();
             });
        } else {
            const params = {
                ...this.newGrowthCycleFields,
                startedAt,
                germinationStartedAt,
                growthCycleTemplateId: templateReference,
                growthCycleTemplateName,
                varietyId: varietyReference,
                varietyName,
                isCompleted: false,
                farmId: farmRef,
            };

            this.isAdding = false;
            // Adding the first todo is a side effect of this action
            this.addGrowthCycleAction(params);
            this.resetForm();
        }
   }

   private resetForm() {
       this.newGrowthCycleFields.name = '';
       this.newGrowthCycleFields.varietyId = '';
       this.newGrowthCycleFields.varietyName = '';
       this.newGrowthCycleFields.growthCycleTemplateId = '';
       this.newGrowthCycleFields.growthCycleTemplateName = '';
       this.newGrowthCycleFields.startedAt = '';
       this.newGrowthCycleFields.isWatered = false;
       this.newGrowthCycleFields.germinationCells = 0;
   }
}
